import React from 'react';
import styles from './HeroSectionWithProduct.module.css';
import deviceImg from '../assets/device22.png';
import { useNavigate } from 'react-router-dom';

const HeroSectionWithProduct = () => {
    const navigate = useNavigate();

    const scrollToVideo = () => {
        const videoSection = document.getElementById('timing-gate-video-section');
        if (videoSection) {
            videoSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.heroContainer}>
                {/* Left Section: Text Content */}
                <div className={styles.textContent}>
                    <h1 className={styles.heroHeading}>
                        Unlock Your Potential with <br />
                    </h1>
                    <h1 className={styles.heroHeading2}>
                        Real-Time Data of <br />
                        <span className={styles.highlightText}>Timing Gates</span>
                    </h1>
                    <div className={styles.divider}></div>
                    <p className={styles.heroSubtext}>
                        Precision Performance Tracking <br /> for Athletes
                    </p>
                    <div className={styles.actionButtons}>
                        <button
                            className={styles.bookNowBtn}
                            onClick={() => navigate('/booking')}
                        >
                            <span className={styles.bookNowIcon}></span>
                            <span className={styles.bookNowText}>Book Now</span>
                        </button>

                        <div
                            className={styles.watchVideo}
                            onClick={scrollToVideo} // Replaced alert with scroll function
                            role="button"
                            tabIndex={0}
                        >
                            <span className={styles.watchText}>
                                Watch our<br />video how<br /> it works
                            </span>
                            <div className={styles.playButton}>
                                <div className={styles.playIcon}></div>
                                <div className={styles.circleText}>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(0deg)', left: '52%', top: '0' }}>S</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(22.5deg)', left: '69%', top: '5%' }}>E</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(45deg)', left: '84%', top: '20%' }}>E</span>
                                    <div className={styles.circleDot} style={{ left: '90%', top: '44%' }}></div>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(90deg)', left: '88%', top: '55%' }}>H</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(129deg)', left: '81%', top: '70%' }}>O</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(148deg)', left: '68%', top: '82%' }}>W</span>
                                    <div className={styles.circleDot} style={{ left: '58%', top: '93%' }}></div>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-165deg)', left: '45%', top: '85%' }}>I</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-145.5deg)', left: '30%', top: '80%' }}>T</span>
                                    <div className={styles.circleDot} style={{ left: '22%', top: '75%' }}></div>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-100.5deg)', left: '8%', top: '55%' }}>W</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-74deg)', left: '9%', top: '38%' }}>O</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-67.5deg)', left: '13%', top: '21%' }}>R</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-45deg)', left: '22%', top: '6px' }}>K</span>
                                    <span className={styles.circleLetter} style={{ transform: 'rotate(-22.5deg)', left: '35%', top: '2%' }}>S</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Pricing Details Section - Moved inside textContent for closer association */}
    
                </div>

                {/* Right Section: Image and Background */}
                <div className={styles.imageSection}>
                    <div className={styles.bgCircle}>
                        <p className={styles.timingGateText}>  Aikyam<br />
                            Timing<br />
                            Gates</p>
                    </div>
                    <img src={deviceImg} alt="Device" className={styles.deviceImage} />
                </div>
            </div>

            {/* Stats Section: Below Hero Container */}
            <div className={styles.statsSection}>
                <div className={styles.statBox}>
                    <div className={styles.statValue}>
                        <span className={styles.mainValue}>0.0001</span>
                        <span className={styles.unitValue}>s</span>
                    </div>
                    <div className={styles.statLabel}>Precise data collection</div>
                </div>
                <div className={styles.statBox}>
                    <div className={styles.statValue}>
                        <span className={styles.mainValue}>20+</span>
                        <span className={styles.unitValue}>hrs</span>
                    </div>
                    <div className={styles.statLabel}>On One Full Charge</div>
                </div>
                <div className={styles.statBox}>
                    <div className={styles.statValue}>
                        <span className={styles.mainValue}>5+</span>
                        <span className={styles.unitValue}>mode</span>
                    </div>
                    <div className={styles.statLabel}>of Operations</div>
                </div>
                <div className={styles.statBox}>
                    <div className={styles.statValue}>
                        <span className={styles.mainValue}>3</span>
                        <span className={styles.unitValue}>mins</span>
                    </div>
                    <div className={styles.statLabel}>of Complete Setup time</div>
                </div>
                <div className={styles.statBox}>
                    <div className={styles.statValue}>
                        <span className={styles.mainValue}>1+</span>
                        <span className={styles.unitValue}>million</span>
                    </div>
                    <div className={styles.statLabel}>Data record store and Analysis</div>
                </div>
                <div className={styles.statBox}>
                    <div className={styles.statValue}>
                        <span className={styles.mainValue}>2X</span>
                    </div>
                    <div className={styles.statLabel}>Boost in Training Performance</div>
                </div>
            </div>
        </div>
    );
};

export default HeroSectionWithProduct;